import MainBody from './indexBody';


const MainDesktop = () => {


    return (

    	<div className="grow bg-neutral-000 flex flex-col w-full items-center shrink-0" style={{paddingTop: '168px', paddingLeft: '0px', paddingBottom: '0px'}}>
    		<div className="grow bg-neutral-000 flex flex-col w-full items-center styles-BaseLayoutDesktop-content styles-BaseLayoutDesktop-content-fullWidth">
    			
    			<MainBody />

    		</div>
    	</div>

    );
}

export default MainDesktop;